module.exports = __webpack_public_path__ + "img/open-Indicator-dropdown.9ceb5a5b.svg";